<template>
    <div class="container-fluid py-5">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="card">
                    <div class="card-body text-center py-5">
                        <i class="mdi mdi-alert-circle-outline text-warning" style="font-size: 72px;"></i>
                        <h3 class="mt-4">Nepoznat Ariba kupac</h3>
                        <p class="text-muted mb-4">
                            ID kupca <strong>{{ buyerId }}</strong> nije konfigurisan u našem sistemu.
                        </p>
                        <p class="text-muted">
                            Molimo Vas da kontaktirate Vašeg administratora kako bi konfigurisao Ariba pristup za ovaj ID.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            buyerId: "",
        };
    },
    created() {
        this.buyerId = this.$route.query.buyerId || "Nepoznat";
    },
};
</script>
